import React, { useState, useLayoutEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import style from "./ThemesLayout.module.css";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AdvanceTheme from "./ThemeComponents/AdvanceTheme";
import BasicTheme from "./ThemeComponents/BasicTheme";
import CustomTheme from "./ThemeComponents/CustomTheme";
import axios from "../../../../axios";
import AddSaveNewTheme from "./ThemeComponents/AddSaveNewTheme";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "../../../../Redux";
import Tooltip from "@material-ui/core/Tooltip";
import Backdrop from "@material-ui/core/Backdrop";
import { getFormId } from "../../IFormDesignerLogic";
import { resetPropertiesThroughThemes, themeNoteResetFunction } from "../../IFormDesignerLogic";
import cloneDeep from "lodash-es/cloneDeep";
import useFocusTrap from "../../../../useFocusTrap.js";
//import { GetStateFromData } from "../../../CustomHooks/CustomHooks.js";
//import { updateStateInRedux } from "../../../../Redux/Actions/FormStateActions.js";
import { GetStateFromData, GetState } from "../../../CustomHooks/CustomHooks.js";
import { updateStateInRedux,updateFormStateContextWithoutRender } from "../../../../Redux/Actions/FormStateActions.js";
import ThemeSelector from "./ThemeSelector.jsx";
import {propertiesResetJSON} from "../../Theme/propertiesResetJSON.js";
import { useMediaQuery } from "@material-ui/core";


const ThemesLayout = (props) => {
  const anchor = "right";

  const { t } = useTranslation(["styles", "translation"]);
  const [headerHeight,setHeaderHeight]=useState();  
  const contexts = GetStateFromData(props.containerId);
  const {
    showAlertConfirmNotifications,
    setThemeResetDone,
    setThemeOpen,
    setThemeResetValDone,
    canvasTop,
    microFrontendData,
    activePage
  } = contexts.contexts;

  const isProcessForm = window?.location?.href?.includes("psh/pmWebDesigner")
  const clonedThemeRef = useRef(cloneDeep(props?.formState2?.theme) || {});
  const clonedTheme = clonedThemeRef.current;
  const {resetNoteTheme} = GetState(
    "resetNoteTheme"
  );
  const dispatch = useDispatch();
  const useStyles = makeStyles({
    root: {
      "& .MuiPopover-root": {
        top: "70px",
      },
      "& .MuiDrawer-root": {
        top: "70px",
      },
      "& .MuiDrawer-modal": {
        top: "70px !important",
        inset: "70px 0px 0px 0px !important",
      },
      "& .MuiBackdrop-root": {
        top: "70px",
      },
      "& .MuiDrawer-paperAnchorRight": {
        width: 430,
        right: t("styles:leftVal"),
        left: t("styles:rightVal"),
        top: "70px",
        overflowY: "unset",
      },
    },
    list: {
      width: 250,
    },
    fullList: {
      width: "auto",
    },
    tooltip: {
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      color: "black",
      border: "#70707075 1px solid",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
      fontSize: 12,
      marginTop: "0px",
    },
    arrow: {
      "&:before": {
        border: "1px solid #70707075",
      },
      color: "white",
      fontSize: 15,
    },
  });

  const matches = useMediaQuery("(min-width: 1181px)");

  const trapRef = useFocusTrap();

  const classes = useStyles();

  const [state, setState] = React.useState(false);

  const [showThemeNameBackdrop, setShowThemeNameBackdrop] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(
    Object.assign({}, props.selectedTheme)
  );
  useEffect(()=>{
    if(document.getElementById("themeHeaderBox")){
      setHeaderHeight(document.getElementById("themeHeaderBox").getBoundingClientRect().height);
    }
  },[resetNoteTheme])
  useEffect(() => {
    if (props.selectedTheme) {
      setSelectedTheme(() => props.selectedTheme);
    }
  }, [props.selectedTheme]);
  
  useEffect(() => {
    dispatch(updateStateInRedux({name:"resetProperties",key:props?.containerId,value:false}))
    dispatch(updateStateInRedux({name:"resetNoteTheme",value:false}))
    themeNoteResetFunction(props?.formState2, propertiesResetJSON)
  }, [])

  const [showTheme, setShowTheme] = useState(false);  
  const [themeHeader, setThemeHeader] = useState("basic");
  
  const clearFunction=(()=>{
    resetPropertiesThroughThemes(props?.formState2,propertiesResetJSON);    
    // setResetPropertiesNew(true)
    dispatch(updateStateInRedux({name:"resetProperties",key:props?.containerId,value:true}))
    dispatch(updateStateInRedux({name: "doclistRerenderCount", value: new Date(), key: props?.containerId}));
    dispatch(updateStateInRedux({name:"resetNoteTheme",value:false}))
  })
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setThemeResetDone(true);
    setThemeResetValDone(Date.now());
    setThemeOpen(false);
    const customCssKeys = [
      "CustomStyle",
      "ApplicationTheme",
      "TextBoxCustomStyle",
      "RadioCustomStyle",
      "CheckBoxCustomStyle",
      "ToggleCustomStyle",
      "ButtonCustomStyle",
      "SectionsCustomStyle",
      "LabelCustomStyle",
      "HorizontalTabs",
      "VerticalTabs",
      "HorizontalWizard",
      "VerticalWizard",
      "Tables",
      "DocList",
    ];
    const customStyleCopy = cloneDeep(props.formState2.theme);
    if (
      props.themeDetailsReset?.appliedTheme &&
      Object.keys(props.themeDetailsReset?.appliedTheme)?.length > 0
    ) {
      props.formData.theme = cloneDeep(props.themeDetailsReset?.appliedTheme);
      props.formState2.theme = cloneDeep(props.themeDetailsReset?.appliedTheme);
      Object.keys(customStyleCopy).forEach((style) => {
        customCssKeys.forEach((customcss) => {
          if (style === customcss) {
            props.formData.theme[customcss] = customStyleCopy?.[customcss];
            props.formState2.theme[customcss] = customStyleCopy?.[customcss];
          }
        });
      });
      dispatch(
        updateStateInRedux({
          name: "doclistRerenderCount",
          value: new Date(),
          key: props.containerId,
        })
      );
    } else {
      if (Object.keys(props.formStateTheme).length > 0) {
        props.formData.theme = cloneDeep(props.formStateTheme);
        props.formState2.theme = cloneDeep(props.formStateTheme);
        Object.keys(customStyleCopy).forEach((style) => {
          customCssKeys.forEach((customcss) => {
            if (style === customcss) {
              props.formData.theme[customcss] = customStyleCopy?.[customcss];
              props.formState2.theme[customcss] = customStyleCopy?.[customcss];
            }
          });
        });
        dispatch(
          updateStateInRedux({
            name: "doclistRerenderCount",
            value: new Date(),
            key: props.containerId,
          })
        );
      }
    }
    setState(open);
    if (props.setShowTheme) {
      props.setShowTheme(false);
    }
  };

  useEffect(() => {
    setState(props.state);
  }, [props.state]);

  useEffect(() => {
    if (document.getElementsByClassName("MuiPopover-root")) {
      if (document.getElementsByClassName("MuiPopover-root")[0]) {
        document.getElementsByClassName("MuiPopover-root")[0].style.top =
          "70px";
      }
      if (document.getElementsByClassName("MuiPopover-root")[1]) {
        document.getElementsByClassName("MuiPopover-root")[1].style.top =
          "70px";
      }
    }
  }, [document.getElementsByClassName("MuiPopover-root")]);

  useLayoutEffect(() => {
    if (
      document.getElementsByClassName("MuiDrawer-modal") &&
      document.getElementsByClassName("MuiDrawer-modal")[0]
    ) {
      console.log("err", document.getElementsByClassName("MuiDrawer-modal"));
      document.getElementsByClassName("MuiDrawer-modal")[0].style.top = "70px";
    }
  }, [document.getElementById("themeHeaderBox")]);

  function showThemechanges(theme) {
    props.handleThemeSelector("showChanges", theme);
  }

  const handleClickAway = (arg) => {
    if (arg === "save") {
      const performSave = () => {
      let formId = getFormId();
      var remainingURL = "/idesign/saveTheme";
      var jsonToSend = selectedTheme;
      jsonToSend["formId"] = formId.toString();

      axios
        .post(remainingURL, jsonToSend, {
          withCredentials: true,
        })
        .then((response) => {
          if (response && response.status === 200) {
            try {
              props.handleThemeSelector("Apply", jsonToSend, "save");

              props.setThemeDetailsReset({
                ...cloneDeep(props.themeDetailsReset || {}),
                appliedTheme: cloneDeep(jsonToSend || {}),
              });
             // window.callSpecifiedFunctions(
            //     { },
            //     "",
            //     "",
            //     true  
            //  );
              console.log("Theme saved");
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "success",
                vertical: "bottom",
                horizontal: "left",
                alertContentMsg: `The theme ${selectedTheme?.themeName} has been updated successfully`,
                autoHideDuration: 4000,
              });
            } catch (e) {
              console.log("Error while Saving Theme " + e);
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentMsg: "THEME_SAVING_ERROR",
                autoHideDuration: 4000,
              });
            }
            
          }
        });
      }
      if(activePage && (props?.formState2?.containerControl ==="wizard_h" || props?.formState2?.containerControl ==="wizard_v" || props?.formState2?.containerControl ==="sidenavigation")){
        const previousTheme = cloneDeep(clonedTheme || {})
        showAlertConfirmNotifications({
          open: true,
          showConfirm: 'showconformationDialogBox',
          alertContentKey: "Applying page theme will override themes applied on associated subforms.",
          alertTitleKey: `${t("Override Subform Themes")}`,
          Button1Key: 'Cancel',
          Button2Key: 'Confirm',
          clearFunction: performSave,
          cancelFunction: () => {
            props.handleThemeSelector("showChanges", previousTheme);
          },
        });
        return;
      }
      performSave();   
        
    } else if (arg === "reset") {
      props.handleThemeSelector("Reset", {});
    } else if (arg === "saveAs") {
      setShowThemeNameBackdrop(true);
    }
  };

  function handleThemeNameBackdrop(action, themeName) {
    if (action === "Save as" && themeName) {
      let formId = getFormId();
      var remainingURL = "/idesign/saveTheme";
      var jsonToSend = selectedTheme;
      jsonToSend["themeName"] = themeName;
      jsonToSend["formId"] = formId.toString();
      axios
        .post(remainingURL, jsonToSend, {
          withCredentials: true,
        })
        .then((response) => {
          if (response && response.status === 200) {
            try {
              props.handleThemeList("add", jsonToSend);
              props.handleThemeSelector("Apply", jsonToSend);
            } catch (e) {
              console.log("Error while Saving Theme As " + themeName + " " + e);
            }
          }
        });
    }

    setShowThemeNameBackdrop(false);
  }
  function handleEscapeKey(e) {
    if (e.code === "Escape" && props?.showTheme === "themeDesigner") {
      props.setShowTheme(false);
    }
  }
  const resetPropertiesFunction = () => {
    showAlertConfirmNotifications({
      open: true,
      showConfirm: "showconformationDialogBox",
      'alertContentKey': "ResetPropertiesContent",
      'alertTitleKey': "ResetPropertiesTitle",
      "Button1Key": 'Cancel',
      "Button2Key": 'Clear',
      "Button2Style" :{"backgroundColor":"#D53D3D"},      
      "clearFunction":clearFunction
    });
  }

  return (
    <div ref={trapRef} tabIndex="0">
      <Backdrop
        open={state}
        style={{
          top: isProcessForm ? "0px": "48px",
          backgroundColor: "#70707050",
          opacity: "1",
          zIndex: 9,
        }}
      >
        <div
          id="themes_layout_Main_iforms"
          tabIndex="0"
          onKeyDown={(e) => handleEscapeKey(e)}
          className={
            style["question-popup"] +
            " " +
            classes.modal +
            " " +
            "formBuilder_main_app"
          }
          anchor={anchor}
          open={state}
          style={{
            height: isProcessForm ? "100vh" : `calc( 100vh - 48px )`,
            top: isProcessForm ? "0px": "48px",
            right: t("styles:themesLayoutRight"),
            left: t("styles:themesLayoutLeft"),
            width: matches ? "36vw" : "56vw"
          }}
          onClose={toggleDrawer(anchor, false)}
          dir={
            window?.psh_configs?.selectedLanguage === "ar" ||
            window?.psh_configs?.selectedLanguage === "ar-SA"
              ? "rtl"
              : "ltr"
          }
        >
          <div className={style.themeHeaderBox} id="themeHeaderBox">
            <div className={style.themeHeader}>              
                <span className={style.themeHeaderName} style={{ marginBottom: "10px !important" }}>
                <span className={style.themeHeaderName1} title={props?.formState2?.themeName || "Newgen Theme"}>{props.themeList && props.themeList.appliedTheme && props.themeList.appliedTheme["themeName"]
                  ? props.themeList.appliedTheme["themeName"]
                  : props?.formState2?.themeName
                  ? props?.formState2?.themeName
                  : "Newgen Theme"}
                  </span>
                <img
                src={require("../../../../Icons/EditTheme.svg").default}
                className={style.themeNameIcon}
                style={{ marginBottom: "10px !important" }}
                alt="Edit Icon"
                onClick={() => setShowTheme("themeSelector")}
              />              
              </span>              
              <img
                src={require("../../../../Icons/GreyCross.svg").default}
                alt="close"
                tabIndex={0}
                className={style.themeCloseIcon}
                onClick={toggleDrawer(anchor, false)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    toggleDrawer(anchor, false);
                  }
                }}
              />
            </div>
            {resetNoteTheme && 
            <div className={style.themeNote}>
             <img src={require("../../../../Icons/themeInfo.svg").default} style={{width:"14px",height:"14px",marginLeft:"5px"}}/>
            <div style={{marginLeft:"7px"}}>
             {`Note : Individual control settings override theme settings. To edit properties in themes, `} 
             <span className={style.themeNoteSpan} onClick={()=>resetPropertiesFunction()}>Reset Individual Properties</span> to theme.
             </div>
            </div>}
            <Row className={style.themeCategoryParent}>
              <Col
                tabIndex={0}
                onClick={() => setThemeHeader("basic")}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setThemeHeader("basic");
                  }
                }}
                className={[
                  style.themeCategoryBasic,
                  themeHeader === "basic" ? style.themeCategorySelected : null,
                ].join(" ")}
              >
                {themeHeader === "basic" ? (
                  <img
                    src={
                      require("../../../../Icons/BasicThemeSelected.svg")
                        .default
                    }
                    alt="close"
                    className={style.squareBoxIconTheme}
                    onClick={() => setThemeHeader("basic")}
                  />
                ) : (
                  <img
                    src={require("../../../../Icons/BasicTheme.svg").default}
                    alt="close"
                    className={style.squareBoxIconTheme}
                    onClick={() => setThemeHeader("basic")}
                  />
                )}
                <div
                  className={[
                    style.themeCategoryText,
                    themeHeader === "basic" ? style.selectedText : null,
                  ].join(" ")}
                  onClick={() => setThemeHeader("basic")}
                >
                  {t("translation:Basic")}
                </div>
              </Col>
              <Col
                tabIndex={0}
                onClick={() => setThemeHeader("advance")}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setThemeHeader("advance");
                  }
                }}
                className={[
                  style.themeCategoryAdvance,
                  themeHeader === "advance"
                    ? style.themeCategorySelected
                    : null,
                ].join(" ")}
              >
                {themeHeader === "advance" ? (
                  <img
                    src={
                      require("../../../../Icons/AdvanceThemeSelected.svg")
                        .default
                    }
                    alt="close"
                    className={style.squareBoxIconTheme}
                    onClick={() => setThemeHeader("advance")}
                  />
                ) : (
                  <img
                    src={
                      require("../../../../Icons/ID_Advance_Theme.svg").default
                    }
                    alt="close"
                    className={style.squareBoxIconTheme}
                    onClick={() => setThemeHeader("advance")}
                  />
                )}
                <div
                  className={[
                    style.themeCategoryText,
                    themeHeader === "advance" ? style.selectedText : null,
                  ].join(" ")}
                  onClick={() => setThemeHeader("advance")}
                >
                  {t("translation:Advanced")}
                </div>
              </Col>
              <Tooltip
                title={t(`translation:Custom CSS Tooltip Content`)}
                classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                arrow
              >
                <Col
                  tabIndex={0}
                  onClick={() => setThemeHeader("customcss")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setThemeHeader("customcss");
                    }
                  }}
                  className={[
                    style.themeCategoryCustomCss,
                    themeHeader === "customcss"
                      ? style.themeCategorySelected
                      : null,
                  ].join(" ")}
                >
                  {themeHeader === "customcss" ? (
                    <img
                      src={
                        require("../../../../Icons/CustomCSSSelected.svg")
                          .default
                      }
                      alt="close"
                      className={style.squareBoxIconTheme}
                      onClick={() => setThemeHeader("customcss")}
                    />
                  ) : (
                    <img
                      src={require("../../../../Icons/CustomCSS.svg").default}
                      alt="close"
                      className={style.squareBoxIconTheme}
                      onClick={() => setThemeHeader("customcss")}
                    />
                  )}

                  <div
                    className={[
                      style.themeCategoryText,
                      themeHeader === "customcss" ? style.selectedText : null,
                    ].join(" ")}
                    onClick={() => setThemeHeader("customcss")}
                  >
                    {t("translation:Custom CSS")}
                  </div>
                </Col>
              </Tooltip>
            </Row>
          </div>
          {themeHeader === "basic" ? (
            <BasicTheme
              headerHeight={headerHeight}              
              containerId={props.containerId}
              themeList={props.themeList}
              key={themeHeader}
              selectedTheme={selectedTheme}
              showThemechanges={(theme) => showThemechanges(theme)}
              applyChanges={(ev, saveOldState) =>
                props.applyChanges(ev, saveOldState)
              }
            />
          ) : themeHeader === "advance" ? (
            <AdvanceTheme
              headerHeight={headerHeight}
              containerId={props.containerId}
              key={themeHeader}
              selectedTheme={selectedTheme}
              showThemechanges={(theme) => showThemechanges(theme)}
              formData={props.formData}
              applyChanges={(ev, saveOldState) =>
                props.applyChanges(ev, saveOldState)
              }
            />
          ) : themeHeader === "customcss" ? (
            <CustomTheme
              headerHeight={headerHeight}              
              containerId={props.containerId}
              key={themeHeader}
              selectedTheme={selectedTheme}
              formData={props.formData}
              applyChanges={(ev, saveOldState) =>
                props.applyChanges(ev, saveOldState)
              }
              setShowThemeNameBackdrop={setShowThemeNameBackdrop}
            />
          ) : (
            <></>
          )}

          {themeHeader !== "customcss" ? (
            <>
              <Row
                className={style.themeFooter}
                style={
                  window?.psh_configs?.selectedLanguage === "ar" ||
                  window?.psh_configs?.selectedLanguage === "ar-SA"
                    ? { justifyContent: "flex-end" }
                    : null
                }
              >
                <Button
                  disableFocusRipple
                  disableRipple
                  tabIndex={0}
                  className={[
                    style.themeFooterButtons,
                    style.saveButton,
                    "formBuilder-MuiButton-outlined",
                  ].join(" ")}
                  onClick={() => handleClickAway("save")}
                >
                  {t("translation:Save")}
                </Button>
                <Button
                  disableFocusRipple
                  disableRipple
                  tabIndex={0}
                  className={[
                    style.themeFooterButtons,
                    style.resetButton,
                    "formBuilder-MuiButton-outlined",
                  ].join(" ")}
                  onClick={() => handleClickAway("reset")}
                >
                  {t("translation:Reset")}
                </Button>
                <Button
                  disableFocusRipple
                  disableRipple
                  tabIndex={0}
                  className={[
                    style.themeFooterButtons,
                    style.saveAsButton,
                    "formBuilder-MuiButton-outlined",
                  ].join(" ")}
                  onClick={() => handleClickAway("saveAs")}
                >
                  {t("translation:SaveAs")}
                </Button>
              </Row>
            </>
          ) : (
            <></>
          )}
        
          {showThemeNameBackdrop === true ? (
            <AddSaveNewTheme
              key={showThemeNameBackdrop}
              handleThemeNameBackdrop={(action, themeName) =>
                handleThemeNameBackdrop(action, themeName)
              }
            />
          ) : (
            <></>
          )}
        </div>
      </Backdrop>
      {showTheme === "themeSelector" && (
        <ThemeSelector
          containerId={props.containerId}
          key={showTheme}
          showTheme={showTheme}
          themeList={props.themeList}
          handleThemeList={(action, newTheme) => props.handleThemeList(action, newTheme)}
          handleThemeSelector={(action, theme) => props.handleThemeSelector(action, theme)}
          setThemeList={props.setThemeList}
        />
      )}
    </div>
  );
};

export default ThemesLayout;
